<mat-toolbar mat-dialog-title [ngClass]="color + '-bg'">
  <mat-icon *ngIf="icon" style="margin-right:10px;">{{icon}}</mat-icon>
  <span class="title">{{ title|trans }}</span>
  <ng-content></ng-content>
  <button *ngIf="!noClose" mat-icon-button [mat-dialog-close] class="close-dialog">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>